import { connect } from 'react-redux'
import Feed from './component'
import { launcherOpenUrl, getAttributes, selectors as imported } from '../../imports'
import { isFetching, getCreatives } from '../../data'

function mapStateToProps(state) {
    const locale = imported.getLocale(state)
    return {
        fetching: isFetching(state),
        creatives: getCreatives(state),
        onAdClick: launcherOpenUrl,
        displaySeconds: getAttributes(locale).displaySeconds,
    }
}

export default connect(mapStateToProps)(Feed)



// WEBPACK FOOTER //
// ./src/features/Creatives/components/Feed/index.js